import { createSlice } from "@reduxjs/toolkit"

const snackbar = createSlice({
  name: "snackbar",
  initialState: {
    open: false,
    message: null,
  },
  reducers: {
    openSnackbar(state, action) {
      state.open = true
      state.message = action.payload.message
    },
    closeSnackbar(state) {
      state.open = false
      state.message = null
    },
  },
})

export class SnackbarPayload {
  constructor(message: String, severity) {
    this.message = message
    this.severity = severity
  }
}

export const selectSnackbarState = (state) => state.snackbar

export default snackbar.reducer

export const { openSnackbar, closeSnackbar } = snackbar.actions
